import { Box, IconButton, Typography } from "@mui/material"
import { FaUsersCog } from "react-icons/fa"
import { BoxInformations, BoxSubtitle, BoxTitle, Container, Image } from "./styles"

interface ICardProps {
  title: string
  subTitle: string
  image?: string
  callback?: () => void
  testId?: string
  Icon?: any
}

export const CardConfig = ({ image, title, subTitle, callback, testId, Icon }: ICardProps) => {
  return (
    <Container data-testid={testId}>
      <Box>
        <Box>
          {Icon && <Image />}
          {image && <img src={image} alt="image" />}
        </Box>
        <BoxInformations>
          <BoxTitle>{title}</BoxTitle>
          <BoxSubtitle>{subTitle}</BoxSubtitle>
        </BoxInformations>
      </Box>
      {callback && (
        <IconButton onClick={callback}>
          <FaUsersCog size={"2rem"} style={{ color: "#757575" }} />
        </IconButton>
      )}
    </Container>
  )
}
